export const TIPOSADJUNTO = [
    {tag:'V', icon:'globe'},
    {tag:'E', icon:'email'},
    {tag:'C', icon:'calendar'},
    {tag:'D', icon:'documents'},
    {tag:'O', icon:'apps'}
]

export const TIPOINIT = {idTipoAdjunto: 5, descripcion: 'Otros', tag: 'O'}